//Core
import React from "react"

//Component
import OneStep from "./OneStep"

//helpers
import { classes } from "../../helpers/classname"

//Style
import style from "./style.module.scss"
import Bounce from "react-reveal/Bounce"

const { Container, grid, Wrapper, titleBox, StepsWrapper } = style

const StepByStepWithImage = ({
  title,
  titleColor,
  full,
  list,
  background,
  fontFamily,
}) => {
  return (
    <section className={classes(Container, grid)} style={background}>
      <div className={classes(Wrapper, grid)}>
        <Bounce left>
          <h3
            className={titleBox}
            style={{
              color: titleColor,
              width: full ? "unset" : "",
              fontFamily: fontFamily,
            }}
          >
            {title}
          </h3>
        </Bounce>

        <div className={classes(StepsWrapper, grid)}>
          {list.map((item, index) => (
            <Bounce
              key={index}
              left={index === 0}
              top={index === 1}
              right={index === 2}
              duration={1500}
            >
              <OneStep {...item} fontFamily={fontFamily}></OneStep>
            </Bounce>
          ))}
        </div>
      </div>
    </section>
  )
}

export default StepByStepWithImage
